import { Badge, Button, Card, CardBody, Col, Label, Row } from "reactstrap";
import { useEffect, useState } from "react";
import moment from "moment";
import { Formik, Form } from "formik";
import { jwtDecode } from "jwt-decode";
import { useApi } from "../../../helper/apiHook";
import { useUpload } from "../items/helper";
import PageLayout from "../../../components/layout/page";
import { uploadIcon } from "../../../constant/icons";
import { useAuth } from "../../../components/auth";
import { getValueByKey } from "../../../utils/generalUtils";
import ModalView from "../../../components/modal";
import { validationSchemaForPptSettings } from "./validation";
import PptUploader from "./PptUploader";

export const PPtSettingsAPI = (
  paging?: boolean,
  payload?: any,
  dataLoad: any = {}
) => {
  return { ...useApi("/ppt-settings", paging, payload, dataLoad) };
};

export default function PptSettings() {
  const [defultTab, setDefultTab] = useState("KIOS");
  const pptApi = PPtSettingsAPI(
    true,
    {
      type: defultTab,
    },
    {
      revalidateIfStale: true,
    }
  );
  const frontImageUploader = useUpload(1);
  const lastImageUploader = useUpload(1);

  const [isModal, setIsModal] = useState(true);
  const [user, setUser] = useState<any>(null);

  const auth = useAuth();
  useEffect(() => {
    const token = getValueByKey("token")
      ? JSON.parse(getValueByKey("token")!)
      : null;

    const decoded: any = token ? jwtDecode(token) : null;
    setUser({
      userId: decoded?.userId,
      name: decoded?.name,
    });
  }, [auth?.user?.token]);
  useEffect(() => {
    if (pptApi?.data && pptApi?.data.length > 0) {
      frontImageUploader.setImagePreviews([
        {
          path: pptApi?.data[0].frontImage ?? "",
          id: "undefined",
          isPrimary: false,
        },
      ]);
      lastImageUploader.setImagePreviews([
        {
          path: pptApi?.data[0].lastImage ?? "",
          id: "undefined",
          isPrimary: false,
        },
      ]);
    }
  }, [pptApi?.data]);
  console.log(pptApi?.data, "pptApi?.data")
  const initialValuesForPptSettings = {
    id: pptApi?.data && pptApi?.data[0]?.id ? pptApi?.data[0]?.id : "",
    frontImage:
      pptApi?.data && pptApi?.data[0]?.frontImage
        ? pptApi?.data[0]?.frontImage
        : "",
    lastImage:
      pptApi?.data && pptApi?.data[0]?.lastImage
        ? pptApi?.data[0]?.lastImage
        : "",
    uploadedBy:
      pptApi?.data && pptApi?.data?.name ? pptApi?.data?.name : user?.name,
    uploadedDate:
      pptApi?.data && pptApi?.data[0]?.uploadedDate
        ? pptApi?.data[0]?.uploadedDate
        : new Date(),
    type: pptApi?.data && pptApi?.data[0]?.type ? pptApi?.data[0]?.type : "",
  };
  // console.log(pptApi?.data[0]?.type, "pptApi?.data[0]?.type")

  return (
    <>
      <PageLayout
        item={
          <>
            {/* <Button color="secondary" onClick={() => setIsModal(true)}>
              {uploadIcon.icon}PPT Settings
            </Button> */}
          </>
        }
        View={
          <>
            <Formik
              initialValues={initialValuesForPptSettings}
              validationSchema={validationSchemaForPptSettings}
              enableReinitialize={pptApi?.data?.length > 0}
              onSubmit={(values: any, actions: any) => {
                console.log(values, "values")
                const data =
                  values.length > 0 ? values : initialValuesForPptSettings;

                values = {
                  ...data,
                  uploadedBy: user?.userId,
                  type: values?.type,
                  uploadedDate: new Date(values.uploadedDate).toISOString(),
                };
                const formdata = new FormData();
                if (
                  frontImageUploader.imagePreviews[0]?.id !== "undefined" &&
                  frontImageUploader.selectedImages[0]
                ) {
                  formdata.append(
                    `frontImage`,
                    frontImageUploader.selectedImages[0]
                  );
                }
                if (
                  lastImageUploader.imagePreviews[0]?.id !== "undefined" &&
                  lastImageUploader.selectedImages[0]
                ) {
                  formdata.append(
                    `lastImage`,
                    lastImageUploader.selectedImages[0]
                  );
                }
                for (const key in values) {
                  if (values[key] !== null && values[key] !== undefined) {
                    formdata.append(key, values[key]);
                  }
                }
                // if (pptApi?.data?.length > 0) {
                //   pptApi.updateValue(formdata).then((result: any) => {
                //     if (result?.status) {
                //       setIsModal(false);
                //     }
                //   });
                // } else {
                pptApi.create(formdata).then((result: any) => {
                  if (result?.status) {
                    setIsModal(false);
                  }
                });
                // }
              }}
            >
              {({
                values,
                setFieldValue,
                // handleSubmit,
                errors,
                setFieldError,
              }) => {
                return (
                  <Form className="form-main ppt-settings">
                    {console.log(values, "values") as any}
                    <div className="ppt-type-settings">
                      <Badge
                        onClick={() => {
                          setFieldValue("type", "KIOS");
                          setDefultTab("KIOS");
                        }}
                        className={`${defultTab === "KIOS" ? "active" : ""}`}
                      >
                        Pole Kiosk
                      </Badge>
                      <Badge
                        onClick={() => {
                          setFieldValue("type", "HORDINGS");
                          setDefultTab("HORDINGS");
                        }}
                        className={`${defultTab === "HORDINGS" ? "active" : ""}`}
                      >
                        Hoardings
                      </Badge>
                    </div>
                    <Card>
                      <CardBody>
                        {values?.uploadedBy ? (
                          <span>
                            <Label className="m-0 text-muted"><svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="5" r="4" stroke="currentColor" stroke-width="1.5" /><path d="M17 16.5C17 18.9853 17 21 9 21C1 21 1 18.9853 1 16.5C1 14.0147 4.58172 12 9 12C13.4183 12 17 14.0147 17 16.5Z" stroke="currentColor" stroke-width="1.5" /></svg>Uploaded by:</Label>
                            <p color="black" className="m-0 w-100 d-inline-block">
                              {values?.uploadedBy}
                            </p>
                          </span>
                        ) : null}
                        {values?.uploadedDate ? (
                          <>
                            <span>
                              <Label className="m-0 text-muted"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z" fill="currentColor" /><path d="M16 17C16.5523 17 17 16.5523 17 16C17 15.4477 16.5523 15 16 15C15.4477 15 15 15.4477 15 16C15 16.5523 15.4477 17 16 17Z" fill="currentColor" /><path d="M12 12C12 12.5523 11.5523 13 11 13C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11C11.5523 11 12 11.4477 12 12Z" fill="currentColor" /><path d="M12 16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16C10 15.4477 10.4477 15 11 15C11.5523 15 12 15.4477 12 16Z" fill="currentColor" /><path d="M6 13C6.55229 13 7 12.5523 7 12C7 11.4477 6.55229 11 6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13Z" fill="currentColor" /><path d="M6 17C6.55229 17 7 16.5523 7 16C7 15.4477 6.55229 15 6 15C5.44772 15 5 15.4477 5 16C5 16.5523 5.44772 17 6 17Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M6 0.75C6.41421 0.75 6.75 1.08579 6.75 1.5V2.26272C7.412 2.24999 8.14133 2.24999 8.94346 2.25H13.0564C13.8586 2.24999 14.588 2.24999 15.25 2.26272V1.5C15.25 1.08579 15.5858 0.75 16 0.75C16.4142 0.75 16.75 1.08579 16.75 1.5V2.32709C17.0099 2.34691 17.2561 2.37182 17.489 2.40313C18.6614 2.56076 19.6104 2.89288 20.3588 3.64124C21.1071 4.38961 21.4392 5.33855 21.5969 6.51098C21.75 7.65018 21.75 9.1058 21.75 10.9435V13.0564C21.75 14.8941 21.75 16.3498 21.5969 17.489C21.4392 18.6614 21.1071 19.6104 20.3588 20.3588C19.6104 21.1071 18.6614 21.4392 17.489 21.5969C16.3498 21.75 14.8942 21.75 13.0565 21.75H8.94359C7.10585 21.75 5.65018 21.75 4.51098 21.5969C3.33856 21.4392 2.38961 21.1071 1.64124 20.3588C0.89288 19.6104 0.560763 18.6614 0.403135 17.489C0.249972 16.3498 0.249985 14.8942 0.25 13.0564V10.9436C0.249985 9.10582 0.249972 7.65019 0.403135 6.51098C0.560763 5.33855 0.89288 4.38961 1.64124 3.64124C2.38961 2.89288 3.33856 2.56076 4.51098 2.40313C4.7439 2.37182 4.99006 2.34691 5.25 2.32709V1.5C5.25 1.08579 5.58579 0.75 6 0.75ZM4.71085 3.88976C3.70476 4.02502 3.12511 4.27869 2.7019 4.7019C2.27869 5.12511 2.02502 5.70476 1.88976 6.71085C1.86685 6.88123 1.8477 7.06061 1.83168 7.25H20.1683C20.1523 7.06061 20.1331 6.88124 20.1102 6.71085C19.975 5.70476 19.7213 5.12511 19.2981 4.7019C18.8749 4.27869 18.2952 4.02502 17.2892 3.88976C16.2615 3.75159 14.9068 3.75 13 3.75H9C7.09318 3.75 5.73851 3.75159 4.71085 3.88976ZM1.75 11C1.75 10.146 1.75032 9.40273 1.76309 8.75H20.2369C20.2497 9.40273 20.25 10.146 20.25 11V13C20.25 14.9068 20.2484 16.2615 20.1102 17.2892C19.975 18.2952 19.7213 18.8749 19.2981 19.2981C18.8749 19.7213 18.2952 19.975 17.2892 20.1102C16.2615 20.2484 14.9068 20.25 13 20.25H9C7.09318 20.25 5.73851 20.2484 4.71085 20.1102C3.70476 19.975 3.12511 19.7213 2.7019 19.2981C2.27869 18.8749 2.02502 18.2952 1.88976 17.2892C1.75159 16.2615 1.75 14.9068 1.75 13V11Z" fill="currentColor" /></svg>Uploaded date:</Label>
                              <p color="black" className="m-0 w-100 d-inline-block">
                                {moment(values?.uploadedDate).format(
                                  "DD-MM-YYYY"
                                )}
                              </p>
                            </span>
                          </>
                        ) : null}
                      </CardBody>
                    </Card>
                    <Row>
                      <PptUploader
                        label="Front Image"
                        id="frontImage"
                        setFieldError={setFieldError}
                        errors={errors}
                        imageUpload={frontImageUploader}
                        setFieldValue={setFieldValue}
                        values={values}
                      />
                      <PptUploader
                        label="Last Image"
                        id="lastImage"
                        setFieldError={setFieldError}
                        errors={errors}
                        imageUpload={lastImageUploader}
                        setFieldValue={setFieldValue}
                        values={values}
                      />
                    </Row>

                    <Col
                      lg="12"
                      className="d-flex justify-content-end gap-2 mt-2"
                    >
                      <Button
                        type="submit"
                        // onClick={(e: any) => {
                        //   handleSubmit(e);
                        // }}
                        solid
                      >
                        Submit
                      </Button>
                    </Col>
                  </Form>
                );
              }}
            </Formik>
          </>
        }
      />
      {/* <ModalView
        modalView={isModal}
        modalName={"PPT Settings"}
        onModalDismiss={() => setIsModal(!isModal)}
      > */}

      {/* </ModalView> */}
    </>
  );
}
